import { useUiStore } from '../../store/uiStore';
import styles from './ToastHost.module.css';

const ICON = { info: 'ℹ️', success: '✓', warn: '⚠️', danger: '✕' } as const;

/** Renders queued toasts. Mount once near the app root. */
export function ToastHost() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismiss);

  if (!toasts.length) return null;
  return (
    <div className={styles.host}>
      {toasts.map((t) => (
        <div key={t.id} className={[styles.toast, styles[t.variant]].join(' ')} role="status">
          <span className={styles.icon} aria-hidden>
            {ICON[t.variant]}
          </span>
          <span>{t.message}</span>
          <button className={styles.dismiss} onClick={() => dismiss(t.id)} aria-label="Chiudi">
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
